<template>
	<div class="avatar-menu">
		<v-menu
			:close-on-content-click="false"
			offset-y
			left
			nudge-bottom="8"
			transition="scale-transition"
			origin="top right"
		>
			<template v-slot:activator="{ on }">
				<v-btn
					icon
					small
					v-on="on"
					class="avatar-menu__activator"
				>
					<v-avatar size="34" color="var(--ui-accent, #104782)">
						<img
							v-if="user && user.picture"
							:src="user.picture"
							:alt="userInitials"
						/>
						<span v-else class="avatar-menu__initials">{{ userInitials }}</span>
					</v-avatar>
				</v-btn>
			</template>

			<v-card class="avatar-menu__card" width="260">
				<div class="avatar-menu__header">
					<v-avatar size="44" color="var(--ui-accent, #104782)">
						<img
							v-if="user && user.picture"
							:src="user.picture"
							:alt="userInitials"
						/>
						<span v-else class="avatar-menu__initials avatar-menu__initials--lg">{{ userInitials }}</span>
					</v-avatar>
					<div class="avatar-menu__info">
						<div class="avatar-menu__name">{{ userName }}</div>
						<div class="avatar-menu__email">{{ user && user.email }}</div>
					</div>
				</div>

				<v-divider />

				<v-list dense class="avatar-menu__list">
					<v-list-item @click="openChangePassword">
						<v-list-item-icon class="mr-3">
							<v-icon size="20">mdi-lock-outline</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>Cambiar contrasena</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-divider />

				<v-list dense class="avatar-menu__list">
					<v-list-item @click="logout" class="avatar-menu__logout-item">
						<v-list-item-icon class="mr-3">
							<v-icon size="20" color="error">mdi-logout</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="error--text">Cerrar sesion</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-card>
		</v-menu>

		<change-password-dialog
			v-model="showChangePassword"
			@success="onPasswordChanged"
		/>
	</div>
</template>

<script>
import ChangePasswordDialog from "~/components/core/ChangePasswordDialog.vue";

export default {
	name: "AvatarMenu",
	components: { ChangePasswordDialog },
	props: {
		user: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			showChangePassword: false,
		};
	},
	computed: {
		userName() {
			if (!this.user) return "";
			return this.user.full_name || this.user.username || "";
		},
		userInitials() {
			if (!this.userName) return "?";
			const parts = this.userName.trim().split(/\s+/);
			if (parts.length >= 2) {
				return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
			}
			return parts[0][0].toUpperCase();
		},
	},
	methods: {
		openChangePassword() {
			this.showChangePassword = true;
		},
		onPasswordChanged() {
			this.$auth.logout();
		},
		logout() {
			this.$auth.logout();
		},
	},
};
</script>

<style scoped>
.avatar-menu__activator {
	margin-right: 4px;
}

.avatar-menu__initials {
	color: #fff;
	font-size: 0.8125rem;
	font-weight: 600;
	letter-spacing: 0.5px;
}

.avatar-menu__initials--lg {
	font-size: 1rem;
}

.avatar-menu__card {
	border-radius: 8px;
	overflow: hidden;
}

.avatar-menu__header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
}

.avatar-menu__info {
	min-width: 0;
}

.avatar-menu__name {
	font-weight: 600;
	font-size: 0.875rem;
	color: var(--ui-text, #1f2937);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.avatar-menu__email {
	font-size: 0.75rem;
	color: var(--ui-text-soft, #6b7280);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.avatar-menu__list {
	padding: 4px 0;
}
</style>
